import PropTypes from "prop-types";
import AlertComponent from "./AlertComponent";
import useResizeEffect from "../../../../hooks/useResizeEffect";
import { useTranslation } from "react-i18next";
import FontAwesome from "../../../utilities/FontAwesome";

const BannerComponent = (props) => {
  const { alerts } = props;
  const { t } = useTranslation("translation");

  function dismiss() {
    props.handleDismiss(Object.assign({}, props, { type: "banner" }));
  }

  useResizeEffect(
    { current: document.querySelector(".navigation-container") },
    () => {
      const navContainer = document.querySelector(
        ".navigation-container",
      ) as HTMLDivElement;
      (
        document.querySelector(".notification-container") as HTMLDivElement
      ).style.top = navContainer.clientHeight + "px";
    },
  );

  return (
    <div role="alert" className="sb-alert-banner alert">
      <FontAwesome
        onClick={dismiss}
        prefix={"fas"}
        name={"fa-times"}
        role="button"
        aria-label={t("Close")}
        style={{ float: "right" }}
      />
      <div className="alert-content">
        {alerts.map((alert) => (
          <AlertComponent key={alert.id} message={alert.message} />
        ))}
      </div>
    </div>
  );
};

BannerComponent.propTypes = {
  alerts: PropTypes.array.isRequired,
  handleDismiss: PropTypes.func,
};

export default BannerComponent;
